import { render, staticRenderFns } from "./space.vue?vue&type=template&id=eae5c50a&"
import script from "./space.vue?vue&type=script&lang=js&"
export * from "./space.vue?vue&type=script&lang=js&"
import style0 from "./space.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports